export const apiUrls = {
  importProspectApplications: ({ id }) => `/workflows/application/workflow/fsl1/import/${id ? id : ''}`,
};



// WEBPACK FOOTER //
// ./src/config/urls.js